// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminGoogleReserveDisableResponse

export type AdminGoogleReserveDisableApiResponse = {
	processed_businesses: number;
	disabled_count: number;
	disabled_businesses: Array<{ id: number; name: string }>;
};

export type AdminGoogleReserveDisable = {
	processed_businesses: number;
	disabled_count: number;
	disabled_businesses: Array<{ id: number; name: string }>;
};

export function hydrateAdminGoogleReserveDisable(data: AdminGoogleReserveDisableApiResponse): AdminGoogleReserveDisable {
	return { ...data };
}